import React from "react";

import OrderStatusPageV1 from "../../component/pages/OrderStatusPage";
import OrderStatusPageV2 from "../../V2/components/pages/OrderStatusPage";

function OrderStatus() {
  const isV2 = process.env.NEXT_PUBLIC_REACT_APP_SKIN === "taxnumber" 
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3"
    || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4";

  if (isV2) {
    return (
      <OrderStatusPageV2 />
    )
  }

  return (
    <OrderStatusPageV1 />
  );
}

export default OrderStatus;
